import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  EquipmentType,
  EquipmentTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesEquipment,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionEquipmentDto } from './dto.type';

export class QuestionEquipmentMapper {
  static dtoToEntity(
    dto: QuestionEquipmentDto,
  ): ImpactCo2Answer<ValuesEquipment> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'EQUIPMENT',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        rentedEquipmentType: validateValueInType<EquipmentType>(
          dto.rentedEquipmentType,
          EquipmentTypeValues,
        ),
        rentalDays: dto.rentalDays,
        quantity: dto.quantity,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesEquipment>,
    projectId: number,
  ): Omit<QuestionEquipmentDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      rentedEquipmentType: answer.values.rentedEquipmentType,
      rentalDays: answer.values.rentalDays,
      quantity: answer.values.quantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
